export default "__VITE_ASSET__y2aelA5Y__"